import { states } from "@/components/molecules/mixins/form.mixin";
import { useMagasinStore } from "@/store/magasin";
import { useAuthStore } from "@/store/auth";
import { usePanierStore } from "@/store/panier";
import { useContextStore } from "@/store/context";
import { useClientStore } from "@/store/client";

export const DEFAULT_ERROR = {
  message: "Votre adresse email ou votre mot de passe est invalide. Merci de vérifier votre saisie."
};


export const containerConnexionEmits = () => ([
  "connected"
])

export const useContainerConnexion = (context) => {

  const route = useRoute();
  const router = useRouter();

  const state = ref(states.DEFAULT);
  const error = ref(null);

  const contextStore = useContextStore();
  const authStore = useAuthStore();
  const panierStore = usePanierStore();
  const magasinStore = useMagasinStore();
  const clientStore = useClientStore();

  const { layout, isMobile } = storeToRefs(contextStore);
  const { connexionCallback, captchaKey } = storeToRefs(authStore);
  const { etatPanier } = storeToRefs(panierStore);
  const { servicePro, id: magasinId, isNational, displaySelectShopPopin: isStoreLocatorVisible } = storeToRefs(magasinStore);
  const { isPro, isProHeader, canCheckoutProInMagasin } = storeToRefs(clientStore);

  const { checkStatus } = panierStore;
  const { login, connexionComplete, executeConnexionCallback } = authStore;
  const { displayOrCloseStoreLocatorPopin } = magasinStore;

  const component = computed(() => {
    return defineAsyncComponent(
      lazyComponents[`/components/organisms/connexion/${layout.value}.vue`]
    );
  })
  const cannotCheckoutPro = computed(() => {
    return !isNational.value && isPro.value && !canCheckoutProInMagasin.value(magasinId.value);
  })
  const magasinHasNoServicePro = computed(() => {
    return !isNational.value && (isPro.value && !servicePro.value);
  })

  const dispatchConnected = async (needReloadPage) => {
    connexionComplete();
    context.emit("connected", needReloadPage);
    executeConnexionCallback();
    if (needReloadPage && !isMobile.value) {
      const query = { ...route.query };
      if (query.magasin_id) {
        delete query.magasin_id;
        await router.replace({ query });
      }
      router.go();
    }
  }

  return {
    state,
    error,
    layout,
    connexionCallback,
    captchaKey,
    etatPanier,
    servicePro,
    magasinId,
    isNational,
    isStoreLocatorVisible,
    isPro,
    isProHeader,
    canCheckoutProInMagasin,
    checkStatus,
    login,
    connexionComplete,
    executeConnexionCallback,
    displayOrCloseStoreLocatorPopin,
    component,
    cannotCheckoutPro,
    magasinHasNoServicePro,
    dispatchConnected
  }
}